import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mg-modal-container-wrap',
  templateUrl: './MgModalContainerWrap.component.html',
  styleUrls: ['./MgModalContainerWrap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgModalContainerWrapComponent {}
